import { render, staticRenderFns } from "./TemporaryLogin.vue?vue&type=template&id=a6354d34"
import script from "./TemporaryLogin.vue?vue&type=script&lang=js"
export * from "./TemporaryLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports